import { isOptionsGroup, type OptionsFilter } from '@mantine/core';

const normalizeSearch = (value: string) =>
  value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase().trim();

export const filterActivitySpheres: OptionsFilter = ({
  options,
  search,
  limit,
}) => {
  const query = normalizeSearch(search);

  return options
    .filter(
      option =>
        !isOptionsGroup(option) && normalizeSearch(option.label).includes(query)
    )
    .slice(0, limit);
};
